module.exports = __webpack_public_path__ + "img/modeling-souvenir-toys.9e53d457.jpeg";